<footer
    matTooltip="Client: {{ version }} | Server: {{ serverVersion }}"
    matTooltipShowDelay="2000"
>
    <span class="sb-footer-platform">Swimbird Portfolio Platform</span>
    <span class="sb-footer-copyright">Copyright © Swimbird AB {{ year }}</span>
    <span class="sb-footer-divider font-weight-bold">|</span>
    <a
        href="https://logo.dev"
        class="sb-footer-attribution text-muted font-weight-regular"
        alt="Logo API"
        target="_blank"
    >
        Logos provided by Logo.dev
    </a>
</footer>
